// extracted by mini-css-extract-plugin
module.exports = {"tableHeaderWithArrow":"table-header-with-arrow_tableHeaderWithArrow__3CLOr","button":"table-header-with-arrow_button__O0EcB","label":"table-header-with-arrow_label__2YTcY"};